// Ampel-Status für den Soll/Ist-Abgleich eines Zeitraums (Tag/Woche/Monat/
// Jahr). Bewusst rein funktional: Eingaben sind bereits aggregierte Ist-/Soll-
// Minuten plus ein ArbZG-Warnungs-Flag — keine Datums-/Kalenderlogik hier,
// damit sich der Status isoliert (ohne DOM/Queries) testen lässt.
//
//   - 'ok'      grün  — Ist erreicht/überschreitet das Soll (oder liegt im
//                       ±Toleranzband darunter): alles im Rahmen.
//   - 'warn'    amber — Ist liegt spürbar, aber nicht dramatisch unter dem Soll.
//   - 'alert'   rot   — ArbZG-Verstoß ODER großes Defizit (< halbes Soll geleistet).
//   - 'neutral' grau  — kein Soll im Zeitraum (Wochenende / kein Wochenplan) →
//                       es gibt nichts zu bewerten.
export type SollIstStatus = 'neutral' | 'ok' | 'warn' | 'alert'

/** Toleranzband: bis zu 15 min unter Soll gilt noch als „im Rahmen" (grün).
 *  Spiegelt den 15-min-Neutral-Puffer des DiffBadge und die ArbZG-15-min-
 *  Pausen-Granularität. */
export const SOLL_IST_OK_TOLERANCE_MIN = 15

export function sollIstStatus(
  actualMin: number,
  targetMin: number,
  hasArbzgWarning = false,
): SollIstStatus {
  // Ein ArbZG-Verstoß (zu lange am Stück / zu wenig Pause) ist immer das
  // lauteste Signal — unabhängig davon, ob das Stunden-Soll erfüllt ist.
  if (hasArbzgWarning) return 'alert'
  // Kein Soll im Zeitraum → nichts zu bewerten (Wochenende, kein Wochenplan).
  if (targetMin <= 0) return 'neutral'
  const diff = actualMin - targetMin
  // Soll erreicht/überschritten oder nur knapp (≤ 15 min) darunter → grün.
  if (diff >= -SOLL_IST_OK_TOLERANCE_MIN) return 'ok'
  // Großes Defizit: weniger als das halbe Soll geleistet → rot.
  if (actualMin < targetMin * 0.5) return 'alert'
  // Moderates Defizit → amber.
  return 'warn'
}
